export const SET_DATA_QUALITY_LOADING_STATE = 'data-quality/SET_DATA_QUALITY_LOADING_STATE';
export const SET_DATA_QUALITY = 'data-quality/SET_DATA_QUALITY';
export const SET_BAR_CHART_DATA = 'data-quality/SET_BAR_CHART_DATA';
export const OPEN_VALIDITY_DRAWER = 'data-quality/OPEN_VALIDITY_DRAWER';
export const UPDATE_VALIDITY_DRAWER = 'data-quality/UPDATE_VALIDITY_DRAWER';
export const CLOSE_VALIDITY_DRAWER = 'data-quality/CLOSE_VALIDITY_DRAWER';
export const SET_FILTERS = 'SET_FILTERS';
//test =======≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠=======≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠=======≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠=======≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠=======≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠=======≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠≠

export const UPDATE_CHARTS = 'data-quality/UPDATE_CHARTS';

export const SET_INITIAL_PERIOD_BAR_CHART_DATA = 'data-quality/SET_INITIAL_PERIOD_BAR_CHART_DATA';

export const CHANGE_CURRENT_PAGE = 'data-quality/CHANGE_CURRENT_PAGE';
